import React from 'react';
import { t } from 'react-switch-lang';
import { makeAutoObservable } from 'mobx';

class LinkModel {
  type = 'viber';

  link = '';

  title = '';

  constructor(data = null) {
    if (data) {
      if (data.type) this.type = data.type;
      if (data.link) this.link = data.link;
      if (data.title) this.title = data.title;
    }
    makeAutoObservable(this);
  }
}

export default LinkModel;
